import React, { useEffect, useState } from 'react';
import { gsap } from 'gsap';
import './LoadingScreen.css';

const LoadingScreen = ({ onComplete }) => {
    const [progress, setProgress] = useState(0);
    const [showSecondText, setShowSecondText] = useState(false);

    useEffect(() => {
        // Simulate loading progress
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + Math.random() * 15 + 5; // Random increment between 5-20
            });
        }, 100);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        // Show second text when progress reaches 50%
        if (progress >= 50 && !showSecondText) {
            setShowSecondText(true);
        }
    }, [progress, showSecondText]);

    useEffect(() => {
        if (progress >= 100) {
            // Animate out the loading screen
            gsap.to('.loading-screen', {
                opacity: 0,
                duration: 0.5,
                onComplete: () => {
                    onComplete();
                }
            });
        }
    }, [progress, onComplete]);

    return (
        <div className="loading-screen">
            <div className="loading-content">
                <div className="loading-text-container">
                    <h1 className={`loading-title ${showSecondText ? 'fade-out' : ''}`}>
                        Jacob Faulkner
                    </h1>
                    <h1 className={`loading-subtitle ${showSecondText ? 'fade-in' : ''}`}>
                        Creative Technologist
                    </h1>
                </div>
                <div className="loading-bar-container">
                    <div className="loading-bar" style={{ width: `${progress}%` }}></div>
                </div>
                <p className="loading-text">{Math.round(progress)}%</p>
            </div>
        </div>
    );
};

export default LoadingScreen; 